import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const DocumentText = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M15 12a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h14zm0-5a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2h10zm0-5a1 1 0 0 1 0 2H9a1 1 0 1 1 0-2h6z"
        fillRule="nonzero"
      />
    </svg>
  );
};

DocumentText.displayName = 'DocumentText';
